export const environment = {
  apiUrl: 'https://aks-dev.interplayers.com.br/marketplace-hubapi/v1',

  //Azure AD
  azureBaseUrl: 'https://:tenant.b2clogin.com/:tenant.onmicrosoft.com/oauth2/v2.0',
  azureGetTokenBaseUrl: 'https://:tenant.b2clogin.com/:tenant.onmicrosoft.com/:police/oauth2/v2.0',
  azureClientId: '11eea3ee-0fb8-43d9-9b76-39ea18a0686c',
  azureClientSecret: 'zYI8Q~ESul-9B8LqLPc8FdN5Q0yD6_PlQ.mUSbmx',
  azureCodeChallenge: 'sTbD6H8_ZYPunDowPRQ_6V2lg1LYaZSl2-8drzc2OVU',
  azurePolicy: 'B2C_1_HUB_API_WEB',
  tenant: 'ecspocad',
  scope: 'https://ecspocad.onmicrosoft.com/23175840-3275-4eff-8de9-e29bc5ae4588/admin',
};
